import Delta from '../typography/Delta'
import Image from 'next/image'

const PreviewInfo = ({ data, user }) => {
  return (
    <div className="flex items-center">
      {data?.image && (
        <div
          className="relative flex-shrink-0 mr-10"
          style={{ width: '136px', height: '101px' }}
        >
          <Image
            className="rounded-md absolute w-full h-full object-center"
            layout="fill"
            objectFit="cover"
            src={data?.image}
            alt=""
          />
        </div>
      )}
      <div>
        <Delta>{data?.title}</Delta>
        {data?.host && (
          <div className="mt-10">
            <span className="font-base font-bold">Host:</span>
            <span className="font-base ml-5 mt-10 ">{data?.host}</span>
          </div>
        )}
        {user && (
          <div className="mt-10">
            <span className="font-base font-bold">Username:</span>
            <span className="font-base ml-5 mt-10 ">{user}</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default PreviewInfo
